/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
export const SpaceDraft = core.serialization.object({
    sourceSpaceId: SpaceId,
    draftSpaceId: SpaceId,
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
    mergedAt: core.serialization.date().optional(),
    deletedAt: core.serialization.date().optional(),
});
